"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRegion = exports.updateRegions = exports.getRegionCourses = exports.getRegion = exports.getRegionPicker = exports.addRegionCourseCombo = exports.getRegionCourseComboById = exports.updateRegionCourseCombo = exports.updateRegionCourseCombos = exports.getRegionCourseCombos = exports.duplicateRegionCourseCombo = exports.deleteRegionCourseCombo = exports.addRegion = exports.deleteRegion = exports.getRegionTimezoneISO = exports.getRegionsFilter = exports.getRegions = exports.getRegionsByIds = exports.getRegionPreferredCourses = exports.getRegionById = void 0;
const _ = require("lodash");
const getRegionById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("regions")
        .select(`id, name, related_regions`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return null;
};
exports.getRegionById = getRegionById;
const getRegionPreferredCourses = async (supabase, id) => {
    const { data, error } = await supabase
        .from("region_preferred_courses")
        .select(`*`)
        .eq("region_id", id);
    if (!error)
        return data;
    return error;
};
exports.getRegionPreferredCourses = getRegionPreferredCourses;
const getRegionsByIds = async (supabase, ids, tableFilter, fields) => {
    const getFilterParam = (query, filter) => {
        switch (filter.type) {
            case "in":
                return query.filter(filter.field, "in", filter.value);
            case "or":
                return query.or(filter.value);
            case "eq":
                return query.eq(filter.field, filter.value);
            case "neq":
                return query.neq(filter.field, filter.value);
            case "like":
                return query.like(filter.field, filter.value);
            case "contains":
                return query.contains(filter.field, filter.value);
            default:
                return query;
        }
    };
    const selectFields = fields || `*, country:country_id ( id, name, slug )`;
    let query = supabase
        .from("regions")
        .select(selectFields)
        .in("id", ids)
        .order("slug", { ascending: true });
    if (tableFilter) {
        // for each filter, add a filter to the query
        tableFilter.forEach((filter) => {
            query = getFilterParam(query, filter);
        });
    }
    const { data, error } = await query;
    if (!error)
        return data;
    return error;
};
exports.getRegionsByIds = getRegionsByIds;
const getRegions = async (supabase, fields) => {
    const selectFields = fields || `*, country:country_id ( id, name, slug )`;
    const { data, error } = await supabase
        .from("regions")
        .select(selectFields)
        .order("slug", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getRegions = getRegions;
const getRegionsFilter = async (supabase, countryIds) => {
    const query = supabase
        .from("regions")
        .select(`id, name`)
        .order("name", { ascending: true });
    //for each country id, add a filter
    let filterString = "";
    if (countryIds.length > 0) {
        countryIds.forEach((id, index) => {
            filterString += `country_id.eq.${id}`;
            if (index < countryIds.length - 1) {
                filterString += ",";
            }
        });
        query.or(filterString);
    }
    const { data, error } = await query;
    if (!error)
        return data;
    return error;
};
exports.getRegionsFilter = getRegionsFilter;
const getRegionTimezoneISO = async (supabase, id) => {
    const { data, error } = await supabase
        .from("regions")
        .select(`utc_offset`)
        .eq("id", id)
        .single();
    if (!error)
        return data?.utc_offset;
    return error;
};
exports.getRegionTimezoneISO = getRegionTimezoneISO;
const deleteRegion = async (supabase, id) => {
    const { data, error } = await supabase
        .from("regions")
        .delete()
        .match({ id: id });
    if (!error)
        return data;
    return error;
};
exports.deleteRegion = deleteRegion;
const addRegion = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase.from("regions").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addRegion = addRegion;
const deleteRegionCourseCombo = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_combos")
        .delete()
        .match({ id: id });
    if (!error)
        return true;
    return false;
};
exports.deleteRegionCourseCombo = deleteRegionCourseCombo;
const duplicateRegionCourseCombo = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_combos")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error) {
        const obj = _.cloneDeep(data);
        obj.id = undefined;
        obj.name = `${obj.name} (Copy)`;
        const { data: dataNew, error } = await supabase
            .from("course_combos")
            .insert(obj);
        if (!error)
            return true;
        return false;
        return false;
    }
    return false;
};
exports.duplicateRegionCourseCombo = duplicateRegionCourseCombo;
const getRegionCourseCombos = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_combos")
        .select(`*`)
        .eq("region_id", id);
    if (!error)
        return data;
    return error;
};
exports.getRegionCourseCombos = getRegionCourseCombos;
const updateRegionCourseCombos = async (supabase, obj) => {
    const { data, error } = await supabase.from("course_combos").upsert(obj);
    if (!error)
        return true;
    return false;
};
exports.updateRegionCourseCombos = updateRegionCourseCombos;
const updateRegionCourseCombo = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data, error } = await supabase
        .from("course_combos")
        .upsert(updateObj)
        .select(`*`)
        .single();
    if (!error)
        return true;
    return false;
};
exports.updateRegionCourseCombo = updateRegionCourseCombo;
const getRegionCourseComboById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_combos")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getRegionCourseComboById = getRegionCourseComboById;
const addRegionCourseCombo = async (supabase, obj) => {
    const { data, error } = await supabase.from("course_combos").insert(obj);
    if (!error)
        return true;
    return false;
};
exports.addRegionCourseCombo = addRegionCourseCombo;
const getRegionPicker = async (supabase) => {
    const { data, error } = await supabase
        .from("regions")
        .select(`id, name`)
        .order("name", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getRegionPicker = getRegionPicker;
const getRegion = async (supabase, id) => {
    const { data, error } = await supabase
        .from("regions")
        .select(`*,
      primary_airport:areas!primary_airport_id(*),
      country:country_id ( id, name, slug ),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getRegion = getRegion;
const getRegionCourses = async (supabase, id) => {
    const { data, error } = await supabase
        .from("courses")
        .select(`*`)
        .or(`alt_region_id.eq.${id},region_id.eq.${id}`);
    if (!error)
        return data;
    return error;
};
exports.getRegionCourses = getRegionCourses;
const updateRegions = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    updateObj.forEach((region) => {
        region.modified_by = user?.id;
        delete region.created_by_user;
        delete region.modified_by_user;
    });
    const { data, error } = await supabase.from("regions").upsert(updateObj);
    if (!error)
        return data;
    return error;
};
exports.updateRegions = updateRegions;
const updateRegion = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.country;
    delete updateObj.primary_airport;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("regions")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateRegion = updateRegion;
